// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app/styles/" + chunkId + "." + {"5688":"100d167da07f563c9ecc","8613":"3cb029b77ffdcd934e3a"}[chunkId] + ".css";
};